import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { heroImages } from '../mock';

const blocks = [
  { t: 'Ideazione & brand design', d: 'Naming, brand identity, guida stile, packaging e primo shooting prodotti.' },
  { t: 'Sviluppo Shopify', d: 'Store performante, mobile-first, integrato con CRM, email e gestionali.' },
  { t: 'Marketing & advertising', d: 'Piano editoriale, campagne Meta e Google, produzione creative testate sui dati.' },
  { t: 'Logistica e operations', d: 'Scelta fulfillment, negoziazione corrieri, resi, gestione picchi stagionali.' },
];

const SviluppoBrand = () => (
  <div className="bg-[#2b2b2b]">
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-[#141414] relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: `url(${heroImages.homeHero})` }} />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Servizi eCommerce</div>
        <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">Sviluppo Brand</h1>
        <p className="text-[#e9dfc0]/85 text-[17px] max-w-3xl leading-relaxed">Siamo imprenditori digitali prima di tutto: sappiamo cosa significa portare online un'idea partendo da zero. Costruiamo brand veri, non solo store.</p>
      </div>
    </section>

    <section className="py-24">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {blocks.map((b) => (
          <div key={b.t} className="bg-[#1e1e1e] border border-[#e9dfc0]/15 rounded-2xl p-8 hover:border-[#e9dfc0]/45 transition-colors">
            <h3 className="font-serif text-white text-2xl mb-3">{b.t}</h3>
            <p className="text-[#e9dfc0]/85 text-[15px] leading-relaxed">{b.d}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="bg-[#3a3a3a] py-24">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-center">
        <div className="aspect-square bg-cover bg-center rounded-2xl" style={{ backgroundImage: `url(${heroImages.logistics2})` }} />
        <div>
          <h2 className="font-serif text-white text-3xl md:text-4xl mb-6">Logistica e gestione operativa</h2>
          <ul className="space-y-3 text-[#e9dfc0]/90">
            {['Onboarding logistico e scelta fulfillment','Negoziazione tariffe corriere e SLA','Gestione resi self-service','Automazioni ordini e picchi stagionali'].map((x) => (
              <li key={x} className="flex items-start gap-3"><Check className="w-5 h-5 text-[#e9dfc0] mt-0.5" /><span>{x}</span></li>
            ))}
          </ul>
        </div>
      </div>
    </section>

    <section className="bg-[#e9dfc0] py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-serif text-[#2b2b2b] text-3xl md:text-4xl mb-6">Hai già un brand avviato e vuoi scalarlo con un partner che investe insieme a te?</h2>
        <Link to="/temporary-management" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#2b2b2b] text-[#e9dfc0] font-medium hover:bg-[#1e1e1e] transition-colors">
          Scopri ETech Temporary Management <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </div>
);

export default SviluppoBrand;
